module.exports = __webpack_public_path__ + "static/media/kid3.983f8ae0.png";